import React from 'react'
import { ButtonStyle } from '../../widgetStyles/Styles'
import { ModalWrapper, ModalContent } from './styles'

export const Modal = ({ onCancel, children }) => {

    const onCancelModal = (e) => {
        if (!e.target.closest(".mcontent")) {
            onCancel()
        }
    }

    return (
        <ModalWrapper className="fade-in" onClick={onCancelModal}>
            <ModalContent className="mcontent">
                {children}
            </ModalContent>
        </ModalWrapper>
    )
}